module.exports = __webpack_public_path__ + "img/u51.86702b96.png";